// chartColors.js - Modern color palette based on Octopus Cybersecurity branding

// Modern color palette
export const CHART_COLORS = {
    // Primary chart colors (modern palette)
    primary: '#064c7b',      // Octopus Deep Blue
    secondary: '#0891b2',    // Cyan/Turquoise
    accent: '#f97316',       // Orange (complementary)

    // Status colors
    success: '#059669',      // Emerald Green (Target line, Connected, Low risk)
    danger: '#dc2626',       // Red (High risk, Violations)
    warning: '#f59e0b',      // Amber (Medium risk, Suspicious, Disconnected)
    info: '#3b82f6',         // Light Blue

    // UI colors
    background: '#f8fafc',
    cardBg: '#ffffff',
    textPrimary: '#0f172a',
    textSecondary: '#64748b',
    border: '#e2e8f0',

    // Grid and axis colors for Recharts
    grid: '#e2e8f0',         // Chart grid lines
    axis: '#94a3b8',         // Axis lines and text/ticks
};

// Device colors (10-color palette for drill-down charts: Compliance & MSB Violations)
export const DEVICE_COLORS_10 = [
    '#0891b2', // Cyan (secondary)
    '#dc2626', // Red (danger)
    '#f97316', // Orange (accent)
    '#f59e0b', // Amber (warning)
    '#059669', // Green (success)
    '#3b82f6', // Blue (info)
    '#8b5cf6', // Purple
    '#ec4899', // Pink
    '#14b8a6', // Teal
    '#84cc16'  // Lime
];

// Device colors (12-color palette for Violations By Device chart)
export const DEVICE_COLORS_12 = [
    '#06b6d4', // Cyan (example from your code)
    '#0891b2', // Secondary
    '#059669', // Success
    '#3b82f6', // Info
    '#dc2626', // Danger
    '#f59e0b', // Warning
    '#8b5cf6', // Purple
    '#ec4899', // Pink
    '#14b8a6', // Teal
    '#f97316', // Accent
    '#84cc16', // Lime
    '#6366f1'  // Indigo
];

// Risk score colors (for pie chart segments)
export const RISK_COLORS = {
    low: CHART_COLORS.success,       // Emerald Green (#059669)
    medium: CHART_COLORS.warning,    // Amber (#f59e0b)
    high: CHART_COLORS.danger        // Red (#dc2626)
};

// Status colors (for pie chart segments)
export const STATUS_COLORS = {
    connected: CHART_COLORS.success,    // Emerald Green (#059669)
    disconnected: CHART_COLORS.warning  // Amber (#f59e0b)
};

// Validation colors (Changes by Date - stacked bar)
export const VALIDATION_COLORS = {
    suspicious: CHART_COLORS.warning,   // Amber (#f59e0b)
    violation: CHART_COLORS.danger,     // Red (#dc2626)
    normal: CHART_COLORS.secondary      // Cyan (#0891b2)
};

// Compliance chart colors
export const COMPLIANCE_COLORS = {
    compliance: CHART_COLORS.secondary, // Cyan (#0891b2)
    target: CHART_COLORS.success        // Emerald Green (#059669)
};

// MSB Violations chart color
export const MSB_VIOLATION_COLOR = CHART_COLORS.danger; // Red (#dc2626)
